import React, { useState, useEffect } from 'react'
import '@/App.css'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import axios from 'axios'
import { Toaster } from './components/ui/sonner'
import { toast } from 'sonner'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import UploadMedicine from './pages/UploadMedicine'
import VerifyMedicines from './pages/VerifyMedicines'
import AllMedicineSets from './pages/AllMedicineSets'
import PushedMedicineSets from './pages/PushedMedicineSets'
import UploadSurgical from './pages/UploadSurgical'
import VerifySurgical from './pages/VerifySurgical'
import AllSurgicalSets from './pages/AllSurgicalSets'
import PushedSurgicalSets from './pages/PushedSurgicalSets'

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
const API = `${BACKEND_URL}/api`

export const AuthContext = React.createContext()

function App() {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      fetchUser()
    } else {
      setLoading(false)
    }
  }, [])

  const fetchUser = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`)
      setUser(response.data)
    } catch (error) {
      console.error('Failed to fetch user:', error)
      localStorage.removeItem('token')
      delete axios.defaults.headers.common['Authorization']
    } finally {
      setLoading(false)
    }
  }

  const login = (token, userData) => {
    localStorage.setItem('token', token)
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    setUser(userData)
  }

  const logout = () => {
    localStorage.removeItem('token')
    delete axios.defaults.headers.common['Authorization']
    setUser(null)
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-lg text-gray-600">Loading...</div>
      </div>
    )
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, API }}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
          <Route path="/register" element={!user ? <Register /> : <Navigate to="/" />} />
          <Route path="/" element={user ? <Dashboard /> : <Navigate to="/login" />} />
          <Route path="/upload" element={user ? <UploadMedicine /> : <Navigate to="/login" />} />
          <Route path="/verify" element={user ? <VerifyMedicines /> : <Navigate to="/login" />} />
          <Route path="/all-sets" element={user ? <AllMedicineSets /> : <Navigate to="/login" />} />
          <Route path="/pushed-sets" element={user ? <PushedMedicineSets /> : <Navigate to="/login" />} />
          <Route path="/upload-surgical" element={user ? <UploadSurgical /> : <Navigate to="/login" />} />
          <Route path="/verify-surgical" element={user ? <VerifySurgical /> : <Navigate to="/login" />} />
          <Route path="/all-surgical-sets" element={user ? <AllSurgicalSets /> : <Navigate to="/login" />} />
          <Route path="/pushed-surgical-sets" element={user ? <PushedSurgicalSets /> : <Navigate to="/login" />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthContext.Provider>
  )
}

export default App